const Search = ({ value, onChange, onSend, disabled }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !disabled) {
      onSend();
    }
  };
  return (
    <div className="w-full h-[38px]  rounded-[7.6px] flex items-center md:pl-3 pl-0">
      <div className="w-full py-1 flex flex-row items-center justify-between bg-[#E5E6E7] rounded-[7.6px]">
        <input
          type="text"
          placeholder="Write your message....."
          value={value}
          onChange={e => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          className="w-full text-[9px] font-inter bg-[#E5E6E7] font-normal leading-[100%] tracking-[0%] text-[#00000096] text-opacity-60 px-2 py-1 rounded-[5px] outline-none border-none"
        />
        <button
          className="w-[40px] h-[25.45px] bg-black rounded-[8px] flex items-center justify-center ml-2"
          onClick={onSend}
          disabled={disabled}
        >
          <img
            src="/icons/search.png"
            alt="Search"
            className="w-[16px] h-[16px]"
          />
        </button>
      </div>
    </div>
  );
};

export default Search;
